/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

import {
  InputLabel,
  InputAdornment,
  IconButton,
  FormHelperText,
  Input,
  Tooltip,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControlWithMargin from '../controls/FormControlWithMargin';

import { Field, getIn } from 'formik';

const PasswordToggleHint = styled(Typography)(() => ({
  marginTop: '5px',
  textAlign: 'left',
  fontSize: '12px',
}));

const PasswordToggleHintIcon = styled(VisibilityOff)(() => ({
  fontSize: '13px',
}));

export const RenderTextField = ({
  field,
  form: { touched, errors, handleChange },
  normalizer,
  label,
  tooltip,
  inputProps,
  labelProps,
  ...others
}) => {
  const [showingPassword, setShowingPassword] = React.useState(false);

  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  const handleClickShowPassword = () => {
    setShowingPassword(!showingPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormControlWithMargin error={touch && error != null} {...others}>
      {tooltip && (
        <Tooltip title={tooltip}>
          <InputLabel shrink {...labelProps}>
            {label} <InfoOutlinedIcon style={{ verticalAlign: 'middle' }} color="action" />
          </InputLabel>
        </Tooltip>
      )}
      {!tooltip && label && (
        <InputLabel shrink {...labelProps}>
          {label}
        </InputLabel>
      )}
      <Input
        name={field.name}
        value={field.value}
        onChange={(e) => {
          if (normalizer) {
            handleChange(field.name)(normalizer(e.target.value));
          } else {
            field.onChange(e);
          }
        }}
        onBlur={field.onBlur}
        {...inputProps}
        type={showingPassword ? 'text' : 'password'}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              size="large"
            >
              {showingPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {touch && error ? (
        <FormHelperText>{error}</FormHelperText>
      ) : (
        <PasswordToggleHint variant="caption">
          Clique no <PasswordToggleHintIcon /> para visualizar a senha digitada
        </PasswordToggleHint>
      )}
    </FormControlWithMargin>
  );
};

const FormPasswordField = ({ name, type, placeholder, ...others }) => {
  return <Field name={name} component={RenderTextField} inputProps={{ type, placeholder }} {...others} />;
};
export { FormPasswordField };
